import { render } from "./TheBreadcrumb.pug?vue&type=template&id=720aeefe&lang=pug"
import script from "./TheBreadcrumb.js?vue&type=script&lang=js"
export * from "./TheBreadcrumb.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__